import { createContext, memo, useContext, useState } from 'react'

import { type NavDropdownType, NavDropdowns, type NetworkItem } from '../constants'

import type React from 'react'
import IntegrationsDropDown from './IntegrationsDropdown'

type FuturesDropDown = {
	i18nLabel: string
	type: NavDropdownType
	items: NetworkItem[] //  (NetworkItem || RewardsItem)[]
}

const NavDropdown = memo(({ i18nLabel, type, items }: FuturesDropDown) => {
	const dropdowns = {
		[NavDropdowns.Futures]: (
			<IntegrationsDropDown i18nLabel={i18nLabel} networks={items as NetworkItem[]} />
		),
	}
	return <DropdownProvider>{dropdowns[type]}</DropdownProvider>
})

const DropdownContext = createContext<{
	isOpen: boolean
	setIsOpen: React.Dispatch<React.SetStateAction<boolean>>
}>({ isOpen: false, setIsOpen: () => {} })

const DropdownProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
	const [isOpen, setIsOpen] = useState(false)
	return (
		<DropdownContext.Provider value={{ isOpen, setIsOpen }}>{children}</DropdownContext.Provider>
	)
}

export function useNavDropdown() {
	return useContext(DropdownContext)
}

export default NavDropdown
